import React from 'react'
import PropTypes from 'prop-types'
import SearchFilter from 'components/global/SearchFilter'

function SearchArea(props) {
  const { searchSelected, searchUnSelected, searchProps, setDisableSelectAll } = props

  const handleDisableSelectAll = (val) => {
    if (val) {
      setDisableSelectAll(true)
    } else {
      setDisableSelectAll(false)
    }
  }

  return (
    <div className="jisr-eligible-people_search-area">
      <SearchFilter
        onSubmit={(val) => {
          handleDisableSelectAll(val.search)
          searchUnSelected(val)
        }}
        {...searchProps}
      />
      <SearchFilter
        onSubmit={(val) => {
          handleDisableSelectAll(val.search)
          searchSelected(val)
        }}
        {...searchProps}
      />
    </div>
  )
}

SearchArea.propTypes = {
  searchSelected: PropTypes.func,
  searchUnSelected: PropTypes.func,
  searchProps: PropTypes.shape(),
  setDisableSelectAll: PropTypes.bool,
}

export default React.memo(SearchArea)
